export default "__VITE_ASSET__70ea5c09__"